/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsfilteredempty2Inputs */

const en_earningsfilteredempty2 = /** @type {(inputs: Earningsfilteredempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no events with tickets in this view.`)
};

const de_earningsfilteredempty2 = /** @type {(inputs: Earningsfilteredempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In dieser Auswahl gibt es keine Events mit Tickets.`)
};

/**
* | output |
* | --- |
* | "There are no events with tickets in this view." |
*
* @param {Earningsfilteredempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsfilteredempty2 = /** @type {((inputs?: Earningsfilteredempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsfilteredempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsfilteredempty2(inputs)
	return de_earningsfilteredempty2(inputs)
});
export { earningsfilteredempty2 as "earningsFilteredEmpty" }